module.exports = __webpack_public_path__ + "static/media/1_Protocol-Formoplast-OSA-20150626.7dc55e21.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2015/1_Protocol-Formoplast-OSA-20150626.pdf
// module id = 181
// module chunks = 0